export const SET_PROCESS_MANAGER_ERROR_CLIENT_CLOSED_TEXT =
    'BACKEND_TEXTS_SET_PROCESS_MANAGER_ERROR_CLIENT_CLOSED_TEXT'
export const SET_TEXTS = 'BACKEND_TEXTS_SET_TEXTS'



// WEBPACK FOOTER //
// ./src/features/Backend/data/texts/constants.js